import { INode } from 'shared/types/tree'
import {
  AssignableNodeTypes,
  NavigableNodeTypes,
  NodeType,
} from 'shared/types/ingestion'
import { NodeIdMap } from '../version_mapping/utility'
import {
  directTKatTreeAccessUrl,
  directTreeAccessUrl,
} from 'infrastructure/api'
import { openTab } from '../Helpers'
import { isLeaf } from 'shared/utils'

export function closestNavigableParent(
  node: NodeSearchParams,
  idMap: NodeIdMap,
): INode {
  return (
    closestAncestorOfType(node, idMap, ...NavigableNodeTypes) || (node as INode)
  )
}

export function isInAssignableTree(node: INode, idMap: NodeIdMap) {
  return !!closestAncestorOfType(node, idMap, ...AssignableNodeTypes)
}

export function getNodeUrl(node: NodeSearchParams, idMap?: NodeIdMap) {
  const navigable = idMap ? closestNavigableParent(node, idMap) : node
  return directTreeAccessUrl({
    treeId: navigable.tree_id!,
    versionId: navigable.version!,
    nodeId: navigable.id,
  })
}

export function getTKatBuilderNodeUrl(node: NodeSearchParams) {
  return directTKatTreeAccessUrl({
    treeId: node.tree_id!,
    versionId: node.version!,
    nodeId: isLeaf(node) ? node.parent_id : node.id,
  })
}

export function openNode(node: NodeSearchParams, idMap?: NodeIdMap) {
  openTab(getNodeUrl(node, idMap))
}

export function openNodeOnTKatBuilder(node: NodeSearchParams) {
  openTab(getTKatBuilderNodeUrl(node))
}

export type NodeSearchParams = {
  id: string
  tree_id?: string
  version?: string
  parent_id?: string
  type: string
}
export function closestAncestorOfType(
  node: { type: string; id: string; parent_id?: string } | undefined,
  idMap: NodeIdMap,
  ...types: NodeType[]
): INode | undefined {
  if (!node) return
  if (types.includes(node.type as NodeType)) {
    return idMap[node.id].node
  }
  if (!node.parent_id) {
    return
  }
  if (node.parent_id in idMap) {
    return closestAncestorOfType(idMap[node.parent_id]?.node, idMap, ...types)
  }
}
